import React from 'react'
import 'app/static/stylus/reusable_components/Expandable.styl'

class Expandable extends React.Component {
    constructor() {
        super(...arguments)
        this.addExpandControl = this.addExpandControl.bind(this)
        this.removeExpandControl = this.removeExpandControl.bind(this)
        this.updateExpandState = this.updateExpandState.bind(this)
        this.expand = this.expand.bind(this)
        this.contract = this.contract.bind(this)
        this.state = {
            expanded: false,
            hasExpandControl: true
        }
    }

    getSeeMoreText() {
        if (this.state.hasExpandControl) {
            if (this.state.expanded) {
                return <span><i className="seeMoreIcon expandableIcon fa fa-angle-up" /> See Less</span>
            } else {
                return <span><i className="seeLessIcon expandableIcon fa fa-angle-down" /> See More</span>
            }
        }
    }

    addExpandControl() {
        return this.setState({
            hasExpandControl: true
        })
    }

    removeExpandControl() {
        return this.setState({
            hasExpandControl: false
        })
    }

    updateExpandState() {}

    expand() {
        return this.setState({
            expanded: true
        })
    }

    contract() {
        return this.setState({
            expanded: false
        })
    }
}

export default Expandable
